module.exports = __webpack_public_path__ + "static/media/thankyou_bg_2022_may.62e0bcb8.png";